import { createStore } from 'vuex'


const state = {
  files: [],
}

const mutations = {
  updateFiles(state, files) {
    state.files = files
  }
}
export default createStore({
  strict: true,
  state,
  mutations
})
